export const model = {
    id: null,
    name: '', 
    percent: '',   
    created_at: '',
    updated_at: ''
};
